import React, {Component} from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";
import Image from "../components/image";
import SEO from "../components/seo";
import "../styles/main.scss";
import UncontrolledLottie from '../components/home/lottie/UncontrolledLottie';
import json from '../components/home/lottie/lf30_black avatar.json';
import Welcome from "../components/home/welcome/Welcome";
import $ from 'jquery';
import About from './../components/home/about/About';
import Portfolio from './../components/home/portfolio/Portfolio';
import Applications from './../components/home/applications/Applications';

//cute console message
const consoleMessage = () => {
  "use strict";
  // console.clear();
  const i = ` padding: 0; 
              color:#000000; 
              line-height:20px; 
              font-size: 14px; 
              font-family:  'Helvetica Neue', sans-serif`,
      n = ["💪🏾", "❤️", "🙏🏾", "👼🏿", "✝️", "🔥", "🍎", "👨🏾‍💻", "🍕"],
      o = n[Math.floor(Math.random() * n.length)];
  console.log("%cMade with " + o + " \nby %cwww.tonyebrown.com    \n", i, "font-family:  'Helvetica Neue', sans-serif; font-weight:700; color: #000;")
}
consoleMessage();
class IndexPage extends Component {
  constructor(props) {
    super(props);

    this.headerLogo = this.headerLogo.bind(this); 
    
    this.state = {
      headerLogoLeft: false,
    }
  }

  

  componentDidMount() {
    window.$ = window.jQuery = $;
    this.loadScripts(
      [
        //first LOAD quicksight sdk function
        "https://unpkg.com/amazon-quicksight-embedding-sdk@1.0.3/dist/quicksight-embedding-js-sdk.min.js"
      ],
      () => {
        this.setState({ scriptLoaded: true }); //scripts loaded
      }
    );
  }

  loadScripts(array, callback) {
    //load third-party scripts
    var loader = function(src, handler) {
      var script = document.createElement("script");
      script.src = src;
      script.onload = script.onreadystatechange = function() {
        script.onreadystatechange = script.onload = null;
        handler();
      };
      var head = document.getElementsByTagName("head")[0];
      (head || document.body).appendChild(script);
    };
    (function run() {
      if (array.length !== 0) {
        loader(array.shift(), run);
      } 
      else {
        callback && callback();
      }
    })();

    //add scroll event listener
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  headerLogo(height) { 
    // console.log("inside headerLogo")

    if (height > 60) {
      this.setState({headerLogoLeft: true})
    }
    else {
      this.setState({headerLogoLeft: false})
    }
  }

  handleScroll = (event) => {
    // console.log("handleScroll invoked", window.pageYOffset);

    
    this.headerLogo(window.pageYOffset);
  }

  render() {  

    // console.log("handleScroll render", this.state.headerLogoLeft);

    return <Layout leftLogo={this.state.headerLogoLeft}
        // onScroll={this.handleScroll}
      >
      <SEO title="Tonye's Blog - Home" keywords={[`Tonye Brown portfolio`, `gatsby`, `application`, `react`, 'graphic design']} />
      <div className="content">
        {/* <div>
          <Image />
          <UncontrolledLottie animationData={json} />
        </div> */}
        {/* <Link to="/posts/">View all posts</Link> */}
        
        <Welcome id="home" />
        <About id="about" />
        <Portfolio id="portfolio" />
        <Applications id="apps" />
      </div>
    </Layout>
  }
}

export default IndexPage;